module.exports = __webpack_public_path__ + "static/media/sitemap_v_3.4966ba44.svg";